import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context/src/app-context';
import { usePriceRowContext } from '../../../price-row-context';
import {
  CaptionText,
  FontColor,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';
import { IconHomeDelivery } from '@prisjakt/ui/icon';
import { MediumUp, MobileOnly } from 'src/ui/block';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import * as S from './styles';

export const HomeDeliveryBadge: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { t } = useAppContext();
  const { newOfferItemExperiment } = usePriceRowContext();

  return (
    <>
      <MediumUp>
        <S.PriceInfoElement>
          <Tooltip
            placement={TooltipPlacement.TOP}
            title={t('product', 'home-delivery.info')}
            renderOnMouseOver
          >
            <S.IconWrapper>
              <IconHomeDelivery color="base400" />
            </S.IconWrapper>
          </Tooltip>
        </S.PriceInfoElement>
      </MediumUp>
      {newOfferItemExperiment && (
        <MobileOnly>
          <S.PriceInfoElement>
            <CaptionText emphasis={FontEmphasis.HIGH} color={FontColor.DARK}>
              {t('product', 'home-delivery.info-3')}
            </CaptionText>
          </S.PriceInfoElement>
        </MobileOnly>
      )}
    </>
  );
};
